import { render, staticRenderFns } from "./BrowseCoursesSearchRelated.vue?vue&type=template&id=d5ef87b6&"
import script from "./BrowseCoursesSearchRelated.vue?vue&type=script&lang=js&"
export * from "./BrowseCoursesSearchRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports